import React, { useState } from "react";
import styles from "./AnalyticsPage.module.css";
import LeftPanel from "../SwapLeftPanel/LeftPanel";
import ConnectWalletHeader from "../header/ConnectWalletHeader";
import Analytics from "./Analytics";

const AnalyticsPage = () => {
  const [walletAddress, setWalletAddress] = useState("");
  const [showPanel, setShowPanel] = useState(false);

  return (
    <div className={styles.page}>
      <LeftPanel walletAddress={walletAddress} />
      <div className={styles.rightPanel}>
        <ConnectWalletHeader
          toAddress="4dJ5ATt3BbJPrbYCZGLAXndi5DPaZZY9j1Sp8Hdh4ApH"
          onWalletConnected={(publicKey) => {
            setWalletAddress(publicKey);
          }}
          showPanel={showPanel}
          setShowPanel={setShowPanel}
        />
        <div className={styles.analyticsWrapper}>
          <Analytics />
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage;
